import React from "react";
import ColAtm from "../../../atomic/Col/Col";
import { PageTitle } from "../../../atomic/PageHeader/PageTitle";
import PageHeaderAtm from "../../../atomic/PageHeader/PageHeader";
import {Link} from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import {makeStyles} from "@material-ui/core/styles";
import {CircularProgress, Hidden, Avatar, Chip} from "@material-ui/core";
import {
    APP,
    CONTENT,
    NETWORK,
    OFFER,
    WEB,
    BOOKING_ENGINE,
    NOT_ALLOWED_DASHBOARD_SHORT,
    NETWORK_COMPETITOR,
    REPUTATION_MANAGEMENT,
    NETWORK_COMPETITOR_DASH
} from "../../../../constants/appUrls.constants";
import BottomNavigation from "@material-ui/core/BottomNavigation/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import { history } from "../../../../utils/history";
import CssBaseline from "@material-ui/core/CssBaseline";
import Card from "@material-ui/core/Card";
import Box from "@material-ui/core/Box";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import {getPropertyName, isDefined} from "../../../../utils";
import Carousel from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';
import NotAllowedCpaPage from "../../Global/NotAllowedPage/NotAllowedDemoPage";
import { propertyProducts } from "../../../../redux/actions/propertyProductsActions";
import Charts from "../../Global/Charts";
import DashboardBottomActions from "../../../molecules/DashboardBottomActions/DashboardBottomActions";
import {getProfile} from "../../../../redux/actions/User/Profile/profileAction";
import {
    getPropertyCpa,
} from "../../../../redux/actions/Network/Inventory/CompetitorActions";

let t = null;

const drawerWidth = 91;
const drawerWidthCollapsed = 280;
const drawerWidthExpanded = 280;

const useStyles = makeStyles(theme => ({
    root: {
        display: 'block',
        width: '100%',
    },
    drawer: {
        width: drawerWidthCollapsed,
        flexShrink: 0,
        zIndex: '999',
    },
    drawerPaper: {
        width: drawerWidthCollapsed,
        height: 'calc(100vh - 81px)',
        marginTop: '81px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
        borderRight: '1px solid #e2e8f0',
        padding: '20px 12px',
        overflowX: 'hidden',
        overflowY: 'auto',
        transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        '&::-webkit-scrollbar': {
            width: 4,
        },
        '&::-webkit-scrollbar-track': {
            background: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#d1d5db',
            borderRadius: 4,
        },
        '@media (min-width: 960px) and (max-width: 1600px)': {
            height: 'calc(125vh - 101px)',
            minHeight: 'calc(125vh - 101px)',
        },
    },
    sidebarList: {
        padding: 0,
        margin: 0,
        listStyle: 'none',
        flex: '1 1 auto',
    },
    sidebarLink: {
        textDecoration: 'none',
        display: 'block',
        marginBottom: 8,
        '&:focus': {
            outline: 'none',
        },
    },
    sidebarItem: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '12px 12px',
        borderRadius: 47,
        cursor: 'pointer',
        transition: 'background 0.2s ease',
        background: 'transparent',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        '&:hover': {
            background: '#f1f5f9',
        },
    },
    sidebarItemActive: {
        background: 'linear-gradient(135deg, #d71f26 0%, #ff4757 100%)',
        '&:hover': {
            background: 'linear-gradient(135deg, #d71f26 0%, #ff4757 100%)',
        },
    },
    sidebarIconWrapper: {
        minWidth: 34,
        width: 34,
        height: 34,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    sidebarIcon: {
        fontSize: 18,
        color: '#64748b',
        transition: 'color 0.2s ease',
    },
    sidebarIconActive: {
        color: '#fff',
    },
    sidebarText: {
        fontSize: 13,
        fontWeight: 600,
        color: '#475569',
        marginLeft: 14,
        opacity: 1,
        transition: 'opacity 0.2s ease 0.1s',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        pointerEvents: 'none',
    },
    sidebarTextVisible: {
        opacity: 1,
    },
    sidebarTextActive: {
        color: '#fff',
    },
    chartsWrapper: {
        flex: '0 0 auto',
        padding: '16px 0',
        borderTop: '1px solid #e2e8f0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    content: {
        flexGrow: 1,
        padding: '24px 68px',
    },
    toolbar: theme.mixins.toolbar,
    // Yeni stiller
    mainCard: {
        borderRadius: 16,
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
        overflow: 'hidden',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
        },
    },
    mainCardHeader: {
        background: 'rgba(236, 129, 35, 0.2)',
        padding: '24px',
        display: 'flex',
        alignItems: 'center',
        gap: 16,
    },
    mainCardIcon: {
        width: 56,
        height: 56,
        borderRadius: 12,
        backgroundColor: 'rgba(255,255,255,0.2)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& i': {
            fontSize: 24,
            color: '#ec8123 !important',
        },
    },
    mainCardTitle: {
        color: '#ec8123 !important',
        fontWeight: 700,
        fontSize: 22,
        margin: 0,
    },
    mainCardSubtitle: {
        color: '#ec8123 !important',
        fontSize: 13,
        marginTop: 4,
    },
    statsCard: {
        borderRadius: 8,
        boxShadow: '0 2px 4px 0 rgba(143, 148, 162, 0.1) !important',
        padding: 24,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
        },
    },
    statsIcon: {
        width: 64,
        height: 64,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 16,
        '& i': {
            fontSize: 24,
        },
    },
    statsValue: {
        fontSize: 36,
        fontWeight: 700,
        color: '#1a1a2e',
        marginBottom: 4,
    },
    statsLabel: {
        fontSize: 14,
        fontWeight: 500,
        color: '#64748b',
    },
    hotelListCard: {
        borderRadius: 8,
        boxShadow: '0 2px 4px 0 rgba(143, 148, 162, 0.1) !important',
        overflow: 'hidden',
    },
    hotelListHeader: {
        padding: '20px 24px',
        borderBottom: '1px solid #e2e8f0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    hotelListTitle: {
        fontSize: 16,
        fontWeight: 700,
        color: '#1a1a2e',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
    },
    hotelListContent: {
        padding: '16px 24px',
        // maxHeight: 280,
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
            width: 4,
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#d1d5db',
            borderRadius: 4,
        },
    },
    hotelItem: {
        display: 'flex',
        alignItems: 'center',
        padding: '8px 8px',
        borderRadius: 8,
        marginBottom: 8,
        backgroundColor: '#f8fafc',
        minHeight: 60,
    },
    hotelAvatar: {
        width: 32,
        height: 32,
        borderRadius: 8,
        backgroundColor: '#e0e7ff',
        color: '#4f46e5',
        fontWeight: 600,
        marginRight: 8,
    },
    hotelName: {
        fontSize: 13,
        fontWeight: 600,
        color: '#1a1a2e',
    },
    hotelLocation: {
        fontSize: 11,
        color: '#64748b',
        marginTop: 2,
    },
    emptyState: {
        textAlign: 'center',
        padding: '40px 24px',
    },
    emptyIcon: {
        fontSize: 48,
        color: '#d1d5db',
        marginBottom: 16,
    },
    emptyText: {
        fontSize: 14,
        color: '#64748b',
        marginBottom: 16,
    },
    actionButton: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        padding: '12px 24px',
        borderRadius: 12,
        backgroundColor: '#f57c00',
        color: '#fff',
        fontWeight: 600,
        fontSize: 14,
        textDecoration: 'none',
        transition: 'all 0.2s ease',
        '&:hover': {
            backgroundColor: '#ef6c00',
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 12px rgba(245, 124, 0, 0.4)',
            color: "#fff"
        },
    },
    quickLinks: {
        display: 'flex',
        gap: 12,
        padding: '16px 24px',
        borderTop: '1px solid #e2e8f0',
        backgroundColor: '#fafafa',
    },
    quickLink: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        padding: '14px 16px',
        borderRadius: 12,
        backgroundColor: '#fff',
        color: '#475569',
        fontWeight: 600,
        fontSize: 13,
        textDecoration: 'none',
        border: '1px solid #e2e8f0',
        transition: 'all 0.2s ease',
        '&:hover': {
            backgroundColor: '#f57c00',
            color: '#fff',
            borderColor: '#f57c00',
        },
    },
}));

class CompetitorAnalysisDashboard extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showSuccessHeader: false,
        };
        t = props.t;
    }

    componentDidMount() {
        // Sol menüdeki Panel / Site Ayarları butonları profil e-postasına bakıyor
        this.props.getProfile();
        document.body.style.backgroundColor = "#f4f7fc";
        this.props.propertyProducts();
        this.props.getPropertyCpa();
    }

    headerStatusShow = () => {
        return (
            <PageHeaderAtm 
                backButton={APP}
                exitText={t('btn-properties')}
                text={getPropertyName()}
                showSuccessHeader={this.props.createStatus}
            />
        );
    };

    render() {
        const { propertyProductsReducer, getCpa, cpaReducer } = this.props;

        const allowedPageNetwork = !propertyProductsReducer.fetching &&
            isDefined(propertyProductsReducer) &&
            isDefined(propertyProductsReducer.get_products) &&
            Object.values(propertyProductsReducer.get_products.data).filter(item => "network" === item.route);

        const allowedPageOffer = !propertyProductsReducer.fetching &&
            isDefined(propertyProductsReducer) &&
            isDefined(propertyProductsReducer.get_products) &&
            Object.values(propertyProductsReducer.get_products.data).filter(item => "offer" === item.route);

        const allowedPageWeb = !propertyProductsReducer.fetching &&
            isDefined(propertyProductsReducer) &&
            isDefined(propertyProductsReducer.get_products) &&
            Object.values(propertyProductsReducer.get_products.data).filter(item => "web" === item.route);

        const allowedPageBookingEngine = !propertyProductsReducer.fetching &&
            isDefined(propertyProductsReducer) &&
            isDefined(propertyProductsReducer.get_products) &&
            Object.values(propertyProductsReducer.get_products.data).filter(item => "booking-engine" === item.route);

        const allowedPagePayment = !propertyProductsReducer.fetching &&
            isDefined(propertyProductsReducer) &&
            isDefined(propertyProductsReducer.get_products) &&
            Object.values(propertyProductsReducer.get_products.data).filter(item => "payment" === item.route);

        const propertyProductCompetitor = !propertyProductsReducer.fetching &&
            isDefined(propertyProductsReducer) &&
            isDefined(propertyProductsReducer.get_products) &&
            Object.values(propertyProductsReducer.get_products.data).filter(item => "competitor-analysis" === item.route);

        const allowedPageReputationManagement = !propertyProductsReducer.fetching &&
            isDefined(propertyProductsReducer) &&
            isDefined(propertyProductsReducer.get_products) &&
            Object.values(propertyProductsReducer.get_products.data).filter(item => "reputation-management" === item.route);

        // Dashboard istatistikleri
        const filteredCompetitors = (getCpa || []).filter(
            hotel => hotel?.competitor_property_source !== "extranetwork"
        );
        const totalCompetitors = filteredCompetitors?.length || '-';
        const isLoading = cpaReducer?.fetching;
        const competitorsList = getCpa || [];

        function Sidebar(props) {
            const classes = useStyles();
            const [isExpanded, setIsExpanded] = React.useState(false);
            const hoverTimeoutRef = React.useRef(null);
            const isNavigatingRef = React.useRef(false);

            const handleMouseEnter = () => {
                if (isNavigatingRef.current) return;
                if (hoverTimeoutRef.current) {
                    clearTimeout(hoverTimeoutRef.current);
                }
                setIsExpanded(true);
            };

            const handleMouseLeave = () => {
                if (hoverTimeoutRef.current) {
                    clearTimeout(hoverTimeoutRef.current);
                }
                hoverTimeoutRef.current = setTimeout(() => {
                    if (!isNavigatingRef.current) {
                        setIsExpanded(false);
                    }
                }, 100);
            };

            const handleLinkClick = () => {
                isNavigatingRef.current = true;
                const currentExpanded = isExpanded;
                setTimeout(() => {
                    isNavigatingRef.current = false;
                    setIsExpanded(currentExpanded);
                }, 500);
            };

            React.useEffect(() => {
                return () => {
                    if (hoverTimeoutRef.current) {
                        clearTimeout(hoverTimeoutRef.current);
                    }
                };
            }, []);

            return (
                <div className={classes.root}>
                    <Drawer
                        className={classes.drawer}
                        variant="permanent"
                        classes={{
                            paper: classes.drawerPaper + " left-sidebar",
                        }}
                        PaperProps={{
                            onMouseEnter: handleMouseEnter,
                            onMouseLeave: handleMouseLeave,
                            style: {
                                width: isExpanded ? drawerWidthExpanded : drawerWidthCollapsed,
                            },
                        }}
                    >
                        <List className={classes.sidebarList}>
                            {props.siderbarItems.map((post, key) => (
                                <React.Fragment key={key}>
                                    <Link 
                                        to={post.link} 
                                        className={classes.sidebarLink}
                                        onClick={handleLinkClick}
                                    >
                                        <Box 
                                            className={`${classes.sidebarItem} ${post.isActive ? classes.sidebarItemActive : ''}`}
                                        >
                                            <Box className={classes.sidebarIconWrapper}>
                                                <i 
                                                    className={`${post.icon} ${classes.sidebarIcon} ${post.isActive ? classes.sidebarIconActive : ''}`} 
                                                />
                                            </Box>
                                            <Typography 
                                                className={`${classes.sidebarText} ${post.isActive ? classes.sidebarTextActive : ''} ${isExpanded ? classes.sidebarTextVisible : ''}`}
                                            >
                                                {post.text}
                                            </Typography>
                                        </Box>
                                    </Link>
                                </React.Fragment>
                            ))}
                        </List>
                        {/* Panel + Site Ayarları: logonun üstünde */}
                        <DashboardBottomActions />

                        <Box className={classes.chartsWrapper}>
                            <Charts />
                        </Box>
                    </Drawer>
                </div>
            );
        }

        const siderbarItems = [
            {id: 1, isActive: false, text: t('enw-product_one-title'), icon: 'fas fa-hotel', link: CONTENT},
            {id: 4, isActive: false, text: t('enw-product_four-title'), icon: 'fas fa-network-wired', link: !propertyProductsReducer.fetching ? isDefined(allowedPageWeb[0]) && allowedPageWeb[0].property_has_product ? WEB : NOT_ALLOWED_DASHBOARD_SHORT + "/web" : "#"},
            {id: 5, isActive: false, text: t('enw-product_six-title'), icon: 'fas fa-calendar-alt', link: !propertyProductsReducer.fetching ? isDefined(allowedPageBookingEngine[0]) && allowedPageBookingEngine[0].property_has_product ? BOOKING_ENGINE : NOT_ALLOWED_DASHBOARD_SHORT + "/booking-engine" : "#"},
            {id: 6, isActive: false, text: t('enw-product_five-title'), icon: 'fas fa-money-bill-wave-alt', link: !propertyProductsReducer.fetching ? isDefined(allowedPagePayment[0]) && allowedPagePayment[0].property_has_product ? "/app/payment" : NOT_ALLOWED_DASHBOARD_SHORT + "/payment" : "#"},
            {id: 3, isActive: false, text: t('enw-product_three-title'), icon: 'fas fa-paperclip', link: !propertyProductsReducer.fetching ? isDefined(allowedPageOffer[0]) && allowedPageOffer[0].property_has_product ? OFFER : NOT_ALLOWED_DASHBOARD_SHORT + "/offer" : "#"},
            {id: 2, isActive: false, text: t('enw-product_two-title'), icon: 'fas fa-chart-network', link: !propertyProductsReducer.fetching ? isDefined(allowedPageNetwork[0]) && allowedPageNetwork[0].property_has_product ? NETWORK : NOT_ALLOWED_DASHBOARD_SHORT + "/network" : "#"},
            {id: 7, isActive: true, text: (
                <>
                    {t('enw-input-competitor')}
                    <span className="newBadge">{t('enw-new_title')}</span>
                </>
            ), icon: 'fas fa-analytics', link: NETWORK_COMPETITOR_DASH},
            {id: 8, isActive: false, text: (
                <>
                    {t('enw-reputation_management-title')}
                    <span className="newBadge">{t('enw-new_title')}</span>
                </>
            ), icon: 'fas fa-comments-alt', link: !propertyProductsReducer.fetching ? isDefined(allowedPageReputationManagement[0]) && allowedPageReputationManagement[0].property_has_product ? REPUTATION_MANAGEMENT : NOT_ALLOWED_DASHBOARD_SHORT + "/reputation-management" : "#"},
        ];

        const classes = useStyles;

        return (
            <>
                <PageTitle title={t('enw-input-competitor')} />
                {this.headerStatusShow()}

                <Grid container className="payment-dashboard rm-dash-main">
                    <Grid item md={1} className="m-none" style={{ height: 'fit-content' }}>
                        <Sidebar siderbarItems={siderbarItems} />
                    </Grid>
                    <Grid item xs={12} className="m-auto web-dashboard">
                        <div>
                            <CssBaseline />
                            {
                                isDefined(propertyProductCompetitor[0]) && !propertyProductCompetitor[0].property_has_product && propertyProductCompetitor[0].status === 1 ?
                                    <Grid item xs={12} lg={6} className="no-buy-product">
                                        <Card className="p-24">
                                            <NotAllowedCpaPage productId={propertyProductCompetitor[0]?.id} isTrialEnd={false} />
                                        </Card>
                                    </Grid>
                                :
                                isDefined(propertyProductCompetitor[0]) && !propertyProductCompetitor[0].property_has_product && propertyProductCompetitor[0].status === 3 ?
                                    <Grid item xs={12} lg={6} className="no-buy-product">
                                        <Card className="p-24">
                                            <NotAllowedCpaPage
                                                trialEndTitle={t('enw-trial_end-product_title')}
                                                trialEndDesc={t('enw-trial_end-product_desc')}
                                                trialEndBtnText={t('enw-not-product_btn')}
                                                isTrialEnd={true}
                                            />
                                        </Card>
                                    </Grid>
                                :
                                <Grid container spacing={3} className="mt-44 be-container-width">
                                    <Grid item xs={12} sm={10} lg={8} className="m-auto web-stats be-dashboard-items">
                                        <DashboardContentWrapper 
                                            isLoading={isLoading}
                                            totalCompetitors={totalCompetitors}
                                            competitorsList={competitorsList}
                                            t={t}
                                        />
                                    </Grid>
                                </Grid>
                            }
                        </div>
                    </Grid>
                </Grid>

                <Hidden mdUp>
                    <BottomNavigation className="m-navigation" value="competitor-analysis">
                        <BottomNavigationAction value="content" icon={<i className="fas fa-hotel" />} onClick={() => { history.push(CONTENT) }} />
                        <BottomNavigationAction value="web" icon={<i className="fas fa-network-wired" />} onClick={() => { history.push(!propertyProductsReducer.fetching ? isDefined(allowedPageWeb[0]) && allowedPageWeb[0].property_has_product ? WEB : NOT_ALLOWED_DASHBOARD_SHORT + "/web" : "#") }} />
                        <BottomNavigationAction value="booking" icon={<i className="fas fa-calendar-alt" />} onClick={() => { history.push(!propertyProductsReducer.fetching ? isDefined(allowedPageBookingEngine[0]) && allowedPageBookingEngine[0].property_has_product ? BOOKING_ENGINE : NOT_ALLOWED_DASHBOARD_SHORT + "/booking-engine" : "#") }} />
                        <BottomNavigationAction value="payment" icon={<i className="fas fa-money-bill-wave-alt" />} onClick={() => { history.push(!propertyProductsReducer.fetching ? isDefined(allowedPagePayment[0]) && allowedPagePayment[0].property_has_product ? "/app/payment" : NOT_ALLOWED_DASHBOARD_SHORT + "/payment" : "#") }} />
                        <BottomNavigationAction value="offer" icon={<i className="fas fa-paperclip" />} onClick={() => { history.push(!propertyProductsReducer.fetching ? isDefined(allowedPageOffer[0]) && allowedPageOffer[0].property_has_product ? OFFER : NOT_ALLOWED_DASHBOARD_SHORT + "/offer" : "#") }} />
                        <BottomNavigationAction value="network" icon={<i className="fas fa-chart-network" />} onClick={() => { history.push(!propertyProductsReducer.fetching ? isDefined(allowedPageNetwork[0]) && allowedPageNetwork[0].property_has_product ? NETWORK : NOT_ALLOWED_DASHBOARD_SHORT + "/network" : "#") }} />
                        <BottomNavigationAction value="competitor-analysis" icon={<i className="fas fa-analytics" />} onClick={() => { history.push(NETWORK_COMPETITOR_DASH) }} />
                        <BottomNavigationAction value="reputation-management" icon={<i className="fas fa-comments-alt" />} onClick={() => { history.push(!propertyProductsReducer.fetching ? isDefined(allowedPageReputationManagement[0]) && allowedPageReputationManagement[0].property_has_product ? REPUTATION_MANAGEMENT : NOT_ALLOWED_DASHBOARD_SHORT + "/reputation-management" : "#") }} />
                    </BottomNavigation>
                </Hidden>

                <style>{`
                    .rm-circular-progress {
                        position: relative !important;
                    }
                    .bg-icon-orange {
                        background-color: #fff3e0 !important;
                    }
                    .bg-icon-purple {
                        background-color: #f3e5f5 !important;
                    }
                    @media screen and (max-width: 768px) {
                        .dashboard-tools > div:nth-last-child(-n + 2) {
                            margin-top: 5px !important;
                        }
                        .hotel-list-content {
                            max-height:285px !important;
                        }
                    }
                    @media screen and (max-width: 400px) {
                        .web-stats .offer-boxes {
                            min-height: 180px !important;
                        }
                    }
                    @media (min-width: 1500px) {
                        .be-container-width {
                            padding: 100px 0px 0px 220px !important;
                        }
                    }
                    @media only screen and (max-device-width: 959px) {
                        .web-dashboard {
                            margin-top: 10px !important;
                        }
                    }
                `}</style>
            </>
        );
    }
}

function DashboardContentWrapper({ isLoading, totalCompetitors, competitorsList, t }) {
    const classes = useStyles();
    
    return (
        <Grid container spacing={3}>
            {/* Sol Taraf - Ana Kart ve İstatistik */}
            <Grid item xs={12} md={6}>
                <Grid container spacing={3}>
                    {/* Ana Kart */}
                    <Grid item xs={12} md={12} className="mobile-order-4">
                        <Card className="offer-dashboard__box-shadow room-box mobile-mb-0" item xs={12}>
                            <Card>
                                <Grid container spacing={3}>
                                    <ColAtm>
                                        <Link style={{display: "contents"}} to={NETWORK_COMPETITOR}>
                                            <ColAtm className="room_dashboard promotion" item xs={4}>
                                                <i className="fas fa-analytics" />
                                            </ColAtm>
                                        </Link>
                                        <ColAtm item xs={8} className="border-shadow">
                                            <CardContent className="w-100">
                                                <Link to={NETWORK_COMPETITOR}>
                                                    <Grid container>
                                                        <Grid item xs={11}>
                                                            <Typography className="orange-title" gutterBottom variant="h5" component="h2">
                                                                { t('enw-input-competitor') }
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={1}>
                                                            <Typography className="completed-step" gutterBottom variant="h5" component="p">
                                                                <span className="orange"><i className="fas fa-arrow-right fs-16" /></span>
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                    <Typography variant="body2" color="textSecondary" component="p">
                                                        { t('enw-pab-dashboard-competitor-desc') }
                                                    </Typography>
                                                </Link>
                                            </CardContent>
                                        </ColAtm>
                                    </ColAtm>
                                    <ColAtm className="carousel-col general-carousel network-promotion-dashboard-menu">
                                        <Hidden xsDown>
                                            <ColAtm className="carousel-col general-carousel">
                                                <Link to={NETWORK_COMPETITOR}>
                                                    {t('enw-input-competitor')}
                                                </Link>
                                            </ColAtm>
                                        </Hidden>
                                        <Hidden smUp>
                                            {/* <Carousel slidesPerPage={3}
                                                    infinite
                                                    keepDirectionWhenDragging
                                                    arrowLeft={<i className="fas fa-caret-left" />}
                                                    arrowRight={<i className="fas fa-caret-right" />}
                                                    addArrowClickHandler
                                                    arrows
                                            > */}
                                                <Link to={NETWORK_COMPETITOR}>
                                                    {t('enw-input-competitor')}
                                                </Link>
                                            {/* </Carousel> */}
                                        </Hidden>
                                    </ColAtm>
                                </Grid>
                            </Card>
                        </Card>
                    </Grid>

                    {/* İstatistik Kartı */}
                    <Grid item xs={12} style={{order: "5"}}>
                        <Paper className={classes.statsCard}>
                            <Box 
                                className={classes.statsIcon} 
                                style={{ backgroundColor: '#e0f2fe' }}
                            >
                                <i className="fas fa-hotel" style={{ color: '#0284c7' }} />
                            </Box>
                            {isLoading ? (
                                <CircularProgress className="rm-circular-progress" color="secondary" size={32} />
                            ) : (
                                <>
                                    <Typography className={classes.statsValue}>
                                        {totalCompetitors}
                                    </Typography>
                                    <Typography className={classes.statsLabel}>
                                        {t('enw-cpa-tracked_hotels')}
                                    </Typography>
                                </>
                            )}
                        </Paper>
                    </Grid>
                </Grid>
            </Grid>

            {/* Sağ Taraf - Takip Edilen Oteller Listesi */}
            <Grid item xs={12} md={6}>
                <Paper className={classes.hotelListCard} style={{ height: '100%' }}>
                    <Box className={classes.hotelListHeader}>
                        <Typography className={classes.hotelListTitle}>
                            <i className="fas fa-list" style={{ color: '#f57c00' }} />
                            {t('enw-cpa_price-title')}
                        </Typography>
                        <Chip 
                            label={`${totalCompetitors} ${t('property_type-hotel')}`}
                            size="small"
                            style={{ 
                                backgroundColor: '#fff3e0', 
                                color: '#f57c00',
                                fontWeight: 600 
                            }}
                        />
                    </Box>
                    <Box className={classes.hotelListContent + " hotel-list-content"}>
                        {isLoading ? (
                            <Box display="flex" justifyContent="center" py={4}>
                                <CircularProgress className="rm-circular-progress" color="secondary" />
                            </Box>
                        ) : competitorsList?.length > 0 ? (
                            <Grid container spacing={2} className="competitor-list-container">
                                {competitorsList
                                    .filter(hotel => hotel?.competitor_property_source !== "extranetwork")
                                    .map((hotel, index) => (
                                    <Grid item xs={12} sm={6} key={hotel?.key || index}>
                                        <Box className={classes.hotelItem} style={{ minHeight: 60, padding: '8px 8px', marginBottom: 8 }}>
                                            <Avatar className={classes.hotelAvatar} style={{ width: 32, height: 32, marginRight: 8 }}>
                                                {hotel?.name?.charAt(0)?.toUpperCase() || 'H'}
                                            </Avatar>
                                            <Box>
                                                <Typography className={classes.hotelName + " competitor-dash-hotel-name"} style={{ fontSize: 13 }}>
                                                    {hotel?.name || '-'}
                                                </Typography>
                                                {hotel?.location && (
                                                    <Typography className={classes.hotelLocation} style={{ fontSize: 11 }}>
                                                        <i className="fas fa-map-marker-alt" style={{ marginRight: 4, fontSize: 9 }} />
                                                        {hotel?.location}
                                                    </Typography>
                                                )}
                                            </Box>
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>
                        ) : (
                            <Box className={classes.emptyState}>
                                <i className={`fas fa-hotel ${classes.emptyIcon}`} />
                                <Typography className={classes.emptyText}>
                                    {t('btn-create_cpa-first-desc')}
                                </Typography>
                                <Link to={NETWORK_COMPETITOR} className={classes.actionButton}>
                                    <i className="fas fa-plus" />
                                    {t('enw-cpa_add-hotel')}
                                </Link>
                            </Box>
                        )}
                    </Box>
                </Paper>
            </Grid>
        </Grid>
    );
}

const mapStateToProps = (state) => ({
    propertyProductsReducer: state.propertyProductsReducer,
    getCpa: state.cpaReducer.getCpa,
    cpaReducer: state.cpaReducer,
});

const mapDispatchToProps = {
    getProfile,
    propertyProducts,
    getPropertyCpa,
};

export default compose(withTranslation('common'))(
    connect(mapStateToProps, mapDispatchToProps)(CompetitorAnalysisDashboard)
);